import PropTypes from 'prop-types';
import styled from 'styled-components';
import { ReactComponent as QrCode } from '../../assets/images/svg/qr-code.svg';
import themeColors from '../../assets/styles/themeColors';

const QrCodeStyled = styled(QrCode)`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  fill: ${({ color }) => color || themeColors.colorBackgroundSecondaryLight};
  stroke: ${themeColors.colorTextPrimary};

  circle {
    stroke: none;
  }
`;

const QrCodeIcon = (props) => <QrCodeStyled {...props} />;

QrCodeIcon.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

QrCodeIcon.defaultProps = {
  w: '40px',
  h: '40px',
};

export default QrCodeIcon;
